import type { UnitCircleWidgetConfig } from '../unit-circle.model';

export const UNIT_CIRCLE_BASIC_PRESET: UnitCircleWidgetConfig = {
  id: 'unit-circle-basic',
  type: 'unit-circle',
  params: {
    point: { angle: '\\pi/4', axisProjections: true, coordinateLabel: true },
  },
  display: {
    coordinateSystem: {
      boundingbox: { xStart: -1.8, xEnd: 1.8, yStart: -1.8, yEnd: 1.8 },
      grid: { type: 'lines', visible: true },
    },
  },
};
